var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fb",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9141 32V17.6H23.2859L24 11.2H18.9141V8.08281C18.9141 6.43481 18.9562 4.8 21.259 4.8H23.5915V0.224219C23.5915 0.155419 21.588 0 19.5611 0C15.328 0 12.6774 2.65151 12.6774 7.52031V11.2H8V17.6H12.6774V32H18.9141Z",
    fill: "#1778F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFacebook);
export default __webpack_public_path__ + "static/media/shareFacebook.fa94fddfb22db3e3d5df5c67a719f436.svg";
export { ForwardRef as ReactComponent };